// Add your JS customizations here
jQuery(document).ready(function ($) {
	init_blog_filters();
	// WHEN X ICON IS CLICKED ON MOBILE AND TABLET
	jQuery(".x-button img").click(function () {
		jQuery(".navbar-toggler").trigger("click");
	});

	// SCROLL DOWN, NAVIGATION BAR TURNS TO BLACK BACKGROUND
	$(Window).scroll(function () {
		var cnt = $(window).scrollTop();
		$("header").removeClass("sticky");
		$('.floating-request-quote').removeClass('active')
		if (cnt >= 150) {
			$("header").addClass("sticky");
		}
		if (cnt >= 500) {
			$('.floating-request-quote').addClass('active');
		} else {
			$('.floating-request-quote').removeClass('hide');
		}		
	});

	$('.hide-button').click(function(){
		$('.floating-request-quote').addClass('hide');
	})

	// request button clicked 
	$('.open-form').click(function(){
		$('.floating-form').addClass('show');		
	});	
	var request_quote = sessionStorage.getItem('request_quote'); 
	$('.floating-form #gform_submit_button_1').click(function(){
		sessionStorage.setItem('request_quote', 'active');    
	});
	if (request_quote == 'active') {
		$('.floating-form').addClass('show');
	}
	$('.close-button img').click(function(){	
		$('.floating-form').removeClass('show');
		sessionStorage.setItem('request_quote', ''); 
	});
	
	
	


	// STAT COUNTER
	// var integ = $('.hero-stats--item h3').text();
	// var firstcol = integ.replace(/[^0-9]/g,'');
	// var lastchar = mp.slice(-1);
	var win = jQuery(window).width();
	if (win <= 992) {
		jQuery(
			(function (jQuery, win) {
				jQuery.fn.inViewport = function (cb) {
					return this.each(function (i, el) {
						function visPx() {
							var H = jQuery(this).height(),
								r = el.getBoundingClientRect(),
								t = r.top,
								b = r.bottom;
							return cb.call(el, Math.max(0, t > 0 ? H - t : b < H ? b : H));
						}
						visPx();
						jQuery(win).on("resize scroll", visPx);
					});
				};
			})(jQuery, window)
		);

		jQuery(function (jQuery) {
			// when scroll viewport
			jQuery(".stat-counter").inViewport(function (px) {
				if (px > 0 && !this.initNumAnim) {
					this.initNumAnim = true;	
					$(this).prop('Counter',0).animate({
						Counter: $(this).text(),
					}, {
						duration: 2000,
						easing: 'swing',
						step: function (now) {
							$(this).text(Math.round(now*10)/10);
						}
					});
				}
			});
		});
	} else {
		$('.stat-counter').each(function (index) {
			var size = $(this).text().split(".")[1] ? $(this).text().split(".")[1].length : 0;
			$(this).prop('Counter',0).animate({
				Counter: $(this).text(),
			}, {
				duration: 2000,
				easing: 'swing',
				step: function (now) {
					$(this).text(Math.round(now*10)/10);
				}
			});
		});
	}

	// Adding comma on every 3 digit number
	function commaSeparateNumber(val){
		while (/(\d+)(\d{3})/.test(val.toString())){
		  val = val.toString().replace(/(\d+)(\d{3})/, '$1'+','+'$2');
		}
		return val;
	}	
	setInterval(function(){
		$('.hero-stats--item h3').each(function(){
			var a = $(this).find('.stat-counter').text();
			$(this).find('.stat-counter').html(commaSeparateNumber(a));
		});
	}, 1);
	
	


	// HOVER SUBMENU
	$(".sub-menu").mouseleave(function () {
		$('.sub-menu').removeClass('hover');
	});
	$(".mout").mouseover(function () {
		$('.sub-menu').removeClass('hover');
	});
	$(".prod").mouseover(function () {
		$('.sub-menu').addClass('hover');
	});

	jQuery("#playButton, #ibexVideo").click(function () {
		var btn = jQuery("#playButton");
		var video = jQuery("#ibexVideo").get(0);

		if (video.paused) {
			jQuery("#ibexVideo").trigger("play");
			btn.attr("src", "/wp-content/themes/ibex-theme/images/pauseicon.png");
			btn.addClass("played");
		} else {
			jQuery("#ibexVideo").trigger("pause");
			btn.attr("src", "/wp-content/themes/ibex-theme/images/playicon.png");
			btn.removeClass("played");
		}
	});
 


	$(".flex-control-thumbs").slick({
		slidesToShow: 3,
		centerMode: true,
		infinite: true,
		autoplay: true,
		focusOnSelect: true,
		autoplaySpeed: 5000,	
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					vertical: false,
				},
			},
			{
				breakpoint: 992,
				settings: {
					vertical: true,
				},
			},
			{
				breakpoint: 768,
				settings: {
					vertical: true,
				},
			},
			{
				breakpoint: 480,
				settings: {
					vertical: false,
				},
			},
		],	
	});  

	$(".video-slider").slick({
		slidesToShow: 3,
		centerMode: true,
		infinite: true,
		autoplay: true,
		focusOnSelect: true,
		autoplaySpeed: 6000,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	$(".logo-slider").slick({
		variableWidth: true,
		slidesToShow: 5,
		centerMode: true,
		infinite: true,
		slidesToShow: 1,
		autoplay: false,
		adaptiveHeight: true,
		draggable:false,
		touchMove:true, 
		initialSlide:3,
	});

	$(".testimonial_slider").slick({
		centerMode: true,
		centerPadding: "60px",
		slidesToShow: 3,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	$(".related ul.products").slick({
		centerMode: true,
		centerPadding: "60px",
		slidesToShow: 5,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: true,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
		],
	});

	// hover of video title bar
	$(".video-slider--title-bar").mouseleave(function () {
		$(this)
			.find("img")
			.attr(
				"src",
				"/wp-content/themes/ibex-theme/images/play-green-small.png"
			);
	});
	$(".video-slider--title-bar").mouseover(function () {
		$(this)
			.find("img")
			.attr(
				"src",
				"/wp-content/themes/ibex-theme/images/play-white-small.png"
			);
	});

	function init_blog_filters() {
		// var wordInput = document.getElementById("s");
		var categoryInput = document.getElementById("category");
		var postType = document.getElementById("post_type");
		// var form_el = document.getElementById("site-filter");
		if (categoryInput) {
			categoryInput.addEventListener("input", function (evt) {
				evt.preventDefault(); 
				let category = categoryInput.value; 
				let url = categoryInput.value;
				 
				window.location = url; 
				if (category === "") return;
			});
		}
	}

	// move wishlist after add to quote
	$(".product-func .yith-wcwl-add-to-wishlist").insertAfter(
		".yith-ywraq-add-to-quote"
	);

	init_training_video_popups();
	function init_training_video_popups() {
		$(".video-link").videoPopup({
			autoplay: true,
			width: "60%",
		});
	}
	$('.product-func .yith-wcwl-add-to-wishlist').insertAfter('.product-func .yith-ywraq-add-to-quote');

	// Toggle the search bar at the top
	$('.navbar-desktop--icons__search, .search-bar .fa-close').click(function(){
		$('.search-bar').toggle('slow');
	})
	$(document).keyup(function(e) { 
		if (e.which === 27) {
			$('.search-bar').toggle('slow');
		}
	});


	// TRIGGER the click action of order button on checkout page
	$('.trigger-order-button').click(function(){
		$('#place_order').trigger('click');
	})

	// thank you page collapse order item section
	$('.collap').click(function(){
		$('.order-items--orders').toggle();
		$(this).toggleClass("collapsed")
	})



	// print thank you page content section
	function printData()
	{
		var printContents = document.getElementById("content").innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
	}
	
	$('.print-button').click(function(){
		printData();
	});


	// move variation to its parent - this can be found on thank you page
	$('.order-items--orders > .row').each(function(){
		$(this).find('.wc-item-meta').appendTo(jQuery(this).find('.pro-desc'));
	})


	var win = $(window).width();
	$(window).on("load", function () {
		if (win <= 991) {
			$('.woof_front_toggle_opened').trigger('click');
			
			$('.single-product .product .product-right h1').prependTo('.product-left');
		}
	});
	
	// enable update button when quantity is changing on cart page
	jQuery('.quantity input').change(function(){
		jQuery('.update-col button').removeAttr("disabled");
	})

	// my account page - adding active classname on sidebar navmenu
	var accntPage = window.location.href;
	$('.woocommerce-MyAccount-navigation > .list-group > a').each(function(){
		var currentP = $(this).attr('href');
		if (accntPage == currentP) {
			$(this).addClass('active');
		}		
	})


	// $('#postcode_lookup').getAddress({
    //     api_key: 'ywAj-uK0x-GLjq-KbS5',
    //     // api_key: 'oCcB-7Wy7-LiS4-Rb88',  
    //     // Prevents the organisation from appearing within address line1
    //     line1_no_organisation: 'true',
    //     output_fields: {
    //         organisation: '#organisation',
    //         line1: '#line1',
    //         line2: '#line2',
    //         line3: '#line3',
    //         town: '#town',
    //         postcode: '#postcode',
    //     }
    // })



	$('.prod-ranges > li.menu-item').hover(function(){
		$('.prod-ranges > li.menu-item').each(function(){
			$(this).find('.sub-menu').hide();	
		})
		// $(this).find('.sub-menu').show();
		$('.append-here').empty();
		$(this).find('.sub-menu').clone().appendTo('.append-here');
	});

});

